

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, User, LogOut } from 'lucide-react';
import logo from '../../../images/logo-integ.png'

export default function Navbar({ logout, setIsModalOpenPerfil }) {
    const navigate = useNavigate();
    const sucursal = localStorage.getItem('sucursal')
    const [open, setOpen] = useState(false);

    const [opcionDolares, setOpcionDolares] = useState('')
    const [opcionPesificado, setOpcionPesificado] = useState('')
    const [opcionPesos, setOpcionPesos] = useState('')
    const [opcionStock, setOpcionStock] = useState('')

    const toggleMenu = () => setOpen(!open);
    const openPerfilCloseMenu = () => { setOpen(false); setIsModalOpenPerfil(true); }

    const handleSelectChange = (event, tipo) => {
        setOpen(false);
        const selected = event.target.value;
        setOpcionDolares(tipo === 'dolares' ? selected : '');
        setOpcionPesificado(tipo === 'pesificado' ? selected : '');
        setOpcionPesos(tipo === 'pesos' ? selected : '');
        setOpcionStock(tipo === 'stock' ? selected : '');

        const ruta = tipo === 'dolares' ? 'tablaMovVentasDolares'
            : tipo === 'pesificado' ? 'tablaMovVentasPesificados'
                : tipo === 'pesos' ? 'tablaMovVentasPesos'
                    : 'tablaStockVentaAnticipada';
        navigate(`/layoutCliente/${ruta}?opcion=${selected}`);
    };

    const selectClass = "bg-transparent text-white/40 hover:text-[#c9a84c] text-[9px] font-black uppercase tracking-widest px-3 py-2 cursor-pointer outline-none transition-colors duration-300 appearance-none border-b border-transparent hover:border-[#c9a84c]/30";

    return (
        <nav className="bg-[#050f08] border-b border-white/5 sticky top-0 z-[100]">
            <div className="px-6 md:px-10 h-14 flex items-center justify-between">

                {/* LOGO */}
                <a href="/layoutCliente/HomeCliente" className="flex items-center gap-3 group no-underline">
                    <div className="w-8 h-8 rounded-lg border border-white/10 group-hover:border-[#c9a84c]/30 flex items-center justify-center transition-all duration-300">
                        <img src={logo} alt="logo" className="w-5 h-5 object-contain" />
                    </div>
                </a>

                {/* DESKTOP MENU */}
                <ul className="hidden lg:flex items-center gap-1 list-none m-0 p-0">
                    {[
                        { label: 'Histórico Dólares', type: 'dolares', options: [['Fecha Factura', 'FechaFormateada'], ['Fecha Vencimiento', 'FechavtoFormateada']], val: opcionDolares },
                        { label: 'Histórico Pesificados', type: 'pesificado', options: [['Fecha Factura', 'FechaFormateada'], ['Fecha Vencimiento', 'FechavtoFormateada']], val: opcionPesificado },
                        { label: 'Histórico Pesos', type: 'pesos', options: [['Fecha Factura', 'FechaFormateada'], ['Fecha Vencimiento', 'FechavtoFormateada']], val: opcionPesos }
                    ].map((sel) => (
                        <li key={sel.type} className="relative">
                            <select
                                onChange={(e) => handleSelectChange(e, sel.type)}
                                value={sel.val}
                                className={selectClass}
                            >
                                <option value="" disabled>{sel.label}</option>
                                {sel.options.map(opt => <option key={opt[1]} value={opt[1]} className="bg-[#050f08] text-white">{opt[0]}</option>)}
                            </select>
                        </li>
                    ))}

                    <div className="w-px h-4 bg-white/10 mx-2" />

                    <li>
                        <a href="/layoutCliente/tablaRemitos"
                            className="text-white/40 hover:text-white text-[9px] font-black uppercase tracking-widest px-3 py-2 transition-colors duration-300 no-underline border-b border-transparent hover:border-[#c9a84c]/30">
                            Remitos
                        </a>
                    </li>
                    <li>
                        <a href="/layoutCliente/tablaPendienteFacturar"
                            className="text-white/40 hover:text-white text-[9px] font-black uppercase tracking-widest px-3 py-2 transition-colors duration-300 no-underline border-b border-transparent hover:border-[#c9a84c]/30">
                            Pendientes de facturar
                        </a>
                    </li>

                    {sucursal !== 'lab' && sucursal !== 'ita' && (
                        <>
                            <div className="w-px h-4 bg-white/10 mx-2" />
                            <li>
                                <select
                                    onChange={(e) => handleSelectChange(e, 'stock')}
                                    value={opcionStock}
                                    className={selectClass}
                                >
                                    <option value="" disabled>Stock</option>
                                    <option value="ventaAnticipada" className="bg-[#050f08] text-white">Venta Anticipada</option>
                                    <option value="total" className="bg-[#050f08] text-white">Stock Total</option>
                                </select>
                            </li>
                        </>
                    )}
                </ul>

                {/* ACCIONES DESKTOP */}
                <div className="hidden lg:flex items-center gap-3">
                    <button
                        onClick={() => setIsModalOpenPerfil(true)}
                        className="w-8 h-8 rounded-lg border border-white/10 hover:border-[#c9a84c]/30 flex items-center justify-center text-white/30 hover:text-[#c9a84c] transition-all duration-300">
                        <User size={14} />
                    </button>
                    <button
                        onClick={logout}
                        className="w-8 h-8 rounded-lg border border-red-500/20 hover:border-red-500/50 hover:bg-red-500/10 flex items-center justify-center text-red-500/50 hover:text-red-400 transition-all duration-300">
                        <LogOut size={14} />
                    </button>
                </div>

                {/* MOBILE TOGGLE */}
                <button className="lg:hidden text-white/50 hover:text-white transition-colors p-1" onClick={toggleMenu}>
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {/* MOBILE MENU */}
            <div className={`fixed inset-x-0 top-[56px] h-[calc(100vh-56px)] bg-[#050f08] z-[150] transition-all duration-500 lg:hidden overflow-y-auto ${open ? "translate-x-0" : "translate-x-full"}`}>
                <div className="p-8 flex flex-col gap-6">

                    {[
                        { label: 'Dólares', type: 'dolares', val: opcionDolares },
                        { label: 'Pesificados', type: 'pesificado', val: opcionPesificado },
                        { label: 'Pesos', type: 'pesos', val: opcionPesos },
                        { label: 'Stock', type: 'stock', val: opcionStock, condition: sucursal !== 'lab' && sucursal !== 'ita' }
                    ].map((item) => (item.condition !== false && (
                        <div key={item.type} className="border-b border-white/5 pb-5">
                            <p className="text-[#c9a84c] text-[9px] font-black uppercase tracking-[0.4em] mb-3">{item.label}</p>
                            <select
                                onChange={(e) => handleSelectChange(e, item.type)}
                                value={item.val}
                                className="w-full bg-white/[0.03] border border-white/8 text-white rounded-xl p-3 text-sm outline-none focus:border-[#c9a84c]/30 transition-all"
                            >
                                <option value="" disabled className="bg-[#050f08]">Seleccionar opción...</option>

                                {item.type !== 'stock' && <>
                                    <option value="FechaFormateada" className="bg-[#050f08] text-white">Por Fecha de Factura</option>
                                    <option value="FechavtoFormateada" className="bg-[#050f08] text-white">Por Fecha de Vencimiento</option>
                                </>}

                                {item.type === 'stock' && <>
                                    <option value="ventaAnticipada" className="bg-[#050f08] text-white">Venta Anticipada</option>
                                    <option value="total" className="bg-[#050f08] text-white">Stock Total</option>
                                </>}
                            </select>
                        </div>
                    )))}

                    <div className="flex flex-col gap-1 mt-2">
                        {[
                            { label: 'Remitos', href: '/layoutCliente/tablaRemitos' },
                            { label: 'Pendientes de facturar', href: '/layoutCliente/tablaPendienteFacturar' },
                        ].map(link => (
                            <a key={link.label} href={link.href}
                                className="text-white/60 hover:text-white text-sm font-bold uppercase tracking-widest no-underline py-4 border-b border-white/5 flex justify-between items-center transition-colors">
                                {link.label}
                                <span className="text-[#c9a84c] text-xs">→</span>
                            </a>
                        ))}
                        <button onClick={openPerfilCloseMenu}
                            className="text-white/60 hover:text-white text-sm font-bold uppercase tracking-widest text-left py-4 border-b border-white/5 flex justify-between items-center transition-colors">
                            Mi Perfil
                            <span className="text-[#c9a84c] text-xs">→</span>
                        </button>
                    </div>

                    <button onClick={logout}
                        className="mt-4 flex items-center justify-center gap-2 bg-red-600/10 hover:bg-red-600 border border-red-500/20 hover:border-red-500 text-red-400 hover:text-white py-4 rounded-xl font-black uppercase tracking-widest text-xs transition-all duration-300">
                        <LogOut size={14} />
                        Cerrar Sesión
                    </button>
                </div>
            </div>
        </nav>
    );
}